import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { MatDialog } from '@angular/material/dialog'
import { ComponentType } from '@angular/cdk/overlay'

export interface OpenResponsiveComponentParams<T, D = unknown> {
	component: ComponentType<T>
	config?: {
		data?: D
	}
	isMobile: boolean
	bottomSheet: MatBottomSheet
	dialog: MatDialog
}

/**
 * Abre um componente responsivamente:
 * - Se for mobile, usa bottomSheet.open.
 * - Se não, usa dialog.open.
 */
export function openResponsiveComponent<T, D>({
	component,
	config = {},
	isMobile,
	bottomSheet,
	dialog,
}: OpenResponsiveComponentParams<T, D>): void {
	const openConfig = { ...config }

	if (isMobile) {
		bottomSheet.open(component, openConfig)
	} else {
		dialog.open(component, {
			...openConfig,
			autoFocus: false,
			width: '375px',
		})
	}
}
